module.exports = __webpack_public_path__ + "static/lsAppFilters-a7865fdd9cda997fab405bd98e72f18d.png";